import React from "react";
import { useTranslation } from "react-i18next";
import { ExportButton } from "./exportButton";
import {
  useAuthentication,
  useExportData,
  useRetrieveCurrentPlanzone,
  useRetrieveProjectReports,
} from "@planzone/view-models";
import {
  ExportsDataTypes,
  ExportsFormats,
  Identifiable,
  Resource,
} from "@planzone/dto";
import { ReportsList } from "./reportsList";
import { Header } from "./header";
import { FilterForm } from "./filterForm";
import { Props } from "./types";
import styles from "./styles.scss";
import { Loader } from "./loader";

function ReportsPage({ project, sideBar }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { account } = useAuthentication();
  const {
    reports,
    isRequestFailure: isRequestFailure,
    isRequestSuccess: isRequestSuccess,
    isRequestPending: isRequestPending,
    retrieveProjectReports,
  } = useRetrieveProjectReports(project);
  const { isRequestPending: isExportRequestPending, exportData } =
    useExportData();
  const [filter, setFilter] = React.useState<{
    resources: Identifiable<Resource>[];
    date: "" | "old" | "new";
  }>({
    date: "",
    resources: [],
  });

  React.useEffect(() => {
    !!project.uuid &&
      !isRequestPending &&
      !isRequestFailure &&
      !isRequestSuccess &&
      retrieveProjectReports(project);
  }, [
    project.uuid,
    retrieveProjectReports,
    isRequestFailure,
    isRequestSuccess,
    isRequestPending,
  ]);

  return (
    <div className={styles.reportsPage}>
      <div className={styles.filters}>
        <FilterForm project={project} filter={filter} setFilter={setFilter} />
      </div>
      <div className={styles.main}>
        {sideBar}
        <div className={styles.list}>
          <div className={styles.header}>
            <Header />
          </div>
          {isRequestPending ? (
            <Loader />
          ) : (
            <>
              <div className={styles.reportsList}>
                <ReportsList
                  project={project}
                  reports={reports}
                  authorFilter={filter.resources}
                  sort={filter.date}
                />
              </div>
            </>
          )}
          <div className={styles.exportButton}>
            <ExportButton
              click={() =>
                !isExportRequestPending &&
                exportData({
                  format: ExportsFormats.EXCEL,
                  author: account,
                  fileName: "reports",
                  data: {
                    type: ExportsDataTypes.PROJECT_REPORTS,
                    data: { reports, project, planzone },
                  },
                })
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export { ReportsPage };
